import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import Button from 'flarum/common/components/Button';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import LockDiscussionModal from './components/LockDiscussionModal';
const DISCUSSION_HERO = 'flarum/forum/components/DiscussionHero';
app.initializers.add('bhic-lock-reason', () => {
  Discussion.prototype.lockReason = Model.attribute('lockReason');

  // flarum/lock registers the 'lock' control (gated on canLock) before this
  // runs: site JS loads after extension JS. Swap its one-click lock for the
  // reason modal; once locked, keep its "Unlock" and add "Edit lock reason".
  // If the lock extension is disabled, there is no 'lock' item and nothing to do.
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!items.has('lock')) return;
    const openModal = () => app.modal.show(LockDiscussionModal, {
      discussion
    });
    if (!discussion.isLocked()) {
      items.setContent('lock', m(Button, {
        icon: "fas fa-lock",
        onclick: openModal
      }, app.translator.trans('flarum-lock.forum.discussion_controls.lock_button')));
    } else {
      items.add('bhicLockReason', m(Button, {
        icon: "fas fa-comment-slash",
        onclick: openModal
      }, app.translator.trans('bhic.forum.lock.edit_reason_button')));
    }
  });

  // Readable by everyone, so the reason shows for every visitor of a locked
  // discussion.
  extend(DISCUSSION_HERO, 'items', function (items) {
    const discussion = this.attrs.discussion;
    if (discussion.isLocked() && discussion.lockReason()) {
      items.add('bhicLockReason', m("div", {
        className: "DiscussionHero-lockReason"
      }, app.translator.trans('bhic.forum.lock.hero_reason', {
        reason: discussion.lockReason()
      })), 5);
    }
  });
});